import React from 'react';
import Page from "@/components/layout/Page";
import StaticContent from '@/components/common/StaticContentPage';

const DailyHelp = () => {
	return (
		<Page pageTitle='Daily Trivia Game'>
      	<StaticContent header={'Daily Challenge'}>
				<p className='font-gReg text-base'>
					{`Sharpen your mind and challenge your knowledge with a fresh set of trivia questions every day. From Geography to Sports, test your prowess in six exciting categories.`}
				</p>
				<div>
					<h3 className={'font-gSemi mb-2  text-base'}>{`Here's how to play:`}</h3>
					<ul className={'list-disc mx-6 flex flex-col gap-2'}>
						<li className='font-gReg text-base'>{`You will receive six questions, one from each category, every day.`}</li>
						<li className='font-gReg text-base'>{`You have 30 seconds to answer each question, so think fast! No time to Google!`}</li>
						<li className='font-gReg text-base'>{`Tap on the correct answer. Correct answers will earn you a colored wedge for that category.`}</li>
						<li className='font-gReg text-base'>{`Aim to collect all six wedges in one day and share your score with friends!`}</li>
					</ul>
				</div>
			</StaticContent>
		</Page>
	);
};

export default DailyHelp;
